/**
 * NotificationService
 * 
 * This service handles all notification-related operations in the application.
 * It provides methods for retrieving system notifications and managing
 * notification states. The service supports operations for both individual
 * users and system-wide notification management.
 * 
 * @class
 */
import { GetNotificationsResponse } from '@frontend/Models/Notifications/NotificationsRequestResponseModels';
import HttpService from './HttpService';
import { pathNotifications } from '@frontend/__settings__/septSoftwarePaths';
const http = new HttpService();

class NotificationsService {
  /**
   * Retrieves all notifications for the current user
   * TODO: Add pagination and filtering options for this.
   * 
   * @returns {Promise<Object>} Object containing notification data
   * @throws {Error} If the API request fails
   */
  static async getNotifications(): Promise<GetNotificationsResponse> {
    const data = await http.get<GetNotificationsResponse>(pathNotifications);
    return data;
  }
}

export default NotificationsService;